// extracted by mini-css-extract-plugin
export default {"sentinel":"Sentinel_sentinel__dLpay","sentinel--nav-showing":"Sentinel_sentinel--nav-showing__dLz+0","nav":"Sentinel_nav__imooj","page":"Sentinel_page__zupFX"};